import { StrictMode, Suspense } from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./Keycloak";
import { Route, Routes } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
//import Nav from "./components/Nav";
import Header from "./components/Header";
import WelcomePage from "./pages/Homepage";
import SecuredPage from "./pages/Securedpage";
import PrivateRoute from "./helpers/PrivateRoute";
import SampleMapPage from "./pages/SampleMapPage";
import ProfilePage from "./pages/Profile";


function Head() {
  const { i18n, t } = useTranslation();
  return (
    <Helmet htmlAttributes={{ lang: i18n.language }}>
      <title>{t("app_name")}</title>
      <meta name="description" content="{t('app_description')}" />
    </Helmet>
  );
}

/**
 * Default routing switch used after onboarding has been completed.
 * Most new routes should be added here.
 */
function DefaultSwitch() {
  return (
    <Routes>
      <Route path="/" element={<WelcomePage />} />
      <Route
        path="/map"
        element={
          <PrivateRoute>
            <SampleMapPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/secured"
        element={
          <PrivateRoute>
            <SecuredPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

function Content() {
  return (
    <div className="centerdiv">
      <Header />
      <DefaultSwitch />
    </div>
  );
}

function App() {
  return (
    <div>
      <ReactKeycloakProvider authClient={keycloak}>
        <StrictMode>
          <Suspense fallback="">
            <HelmetProvider>
              <Head />
              <Content />
            </HelmetProvider>
          </Suspense>
        </StrictMode>
      </ReactKeycloakProvider>
    </div>
    /*
    <div>
      <ReactKeycloakProvider authClient={keycloak}>
        <StrictMode>
          <Nav />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<WelcomePage />} />
              <Route
                path="/secured"
                element={
                  <PrivateRoute>
                    <SecuredPage />
                  </PrivateRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </StrictMode>
      </ReactKeycloakProvider>
    </div>
    */
  );
}

export default App;
